import React from 'react'

export default ({ ...props }) => (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='16' cy='16' r='15.5' fill='white' stroke='#B7B7B7' />
    <path
      d='M22.2663 16.5679C22.5558 16.5698 22.8175 16.335 22.8507 16.043C22.8839 15.7509 22.6746 15.5133 22.3845 15.5107C14.4962 15.4618 17.8711 15.4834 9.73521 15.4321C9.44577 15.4302 9.18406 15.665 9.15083 15.9571C9.13363 16.1143 9.18572 16.2559 9.2833 16.3535C9.36674 16.437 9.48388 16.4881 9.61705 16.4893C17.5283 16.5384 14.105 16.5164 22.2663 16.5679Z'
      fill='#0D0D0D'
    />
  </svg>
)
